// ============================================================
// ROLE GUARD — Blocks access to pages the current role can't see.
// If a user navigates directly to a restricted URL, redirect to dashboard.
// ============================================================

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getAllowedNavIds, NAV_ITEMS } from '../utils/constants';

/**
 * Usage:
 *   <RoleGuard navId="users">
 *     <UserManagement />
 *   </RoleGuard>
 *
 * navId must match the `id` field in NAV_ITEMS.
 * If the user's role doesn't have access, they're redirected to /admin/dashboard.
 */
const RoleGuard = ({ navId, children }) => {
  const { user } = useAuth();
  const adminRole = user?.admin_role;

  // super_admin or null → full access
  const allowedIds = getAllowedNavIds(adminRole);
  if (allowedIds === null || allowedIds.includes(navId)) {
    return children;
  }

  // Not allowed — find the first page they DO have access to
  const firstAllowed = NAV_ITEMS.find(item => allowedIds.includes(item.id));
  return <Navigate to={firstAllowed?.path || '/admin/dashboard'} replace />;
};

export default RoleGuard;
